//export const ServerLink = "http://localhost:8000/api";
export const ServerLink = "https://myadmin.smartpurse.ng/api";
//export const RedirectLink = "http://127.0.0.1:3000"
//export const ServerLink = "https://apisp.dinduenergy.com/api"; 
export const RedirectLink = "https://smartpurse.ng"
//export const fileLink = "http://localhost:8000/";
export const fileLink = "https://myadmin.smartpurse.ng/";
